import React from 'react';

import PageLayout from '../../layout/PageLayout';
import SearchPriceOffersContent from '../../layout/SearchPriceOffersContent';

const SearchPriceOffersPage = () => (
  <PageLayout>
    <SearchPriceOffersContent />
  </PageLayout>
);

export default SearchPriceOffersPage;
